import * as React from "react";
import classnames from "classnames";
/* empty css                 */
const LineItemRowItem = ({ children, className, ...rest }) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("line-item-row__item", className) }, children);
const LineItemRow = ({
  children,
  className,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("line-item-row", className) }, children);
LineItemRow.Item = LineItemRowItem;
export {
  LineItemRow
};
//# sourceMappingURL=LineItemRow.js.map
